export default "__VITE_ASSET__Bh$q_ZAn__"